import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const EditIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M12 20H21M16.5 3.5C16.9 3.1 17.44 2.88 18 2.88C18.28 2.88 18.55 2.93 18.81 3.04C19.07 3.15 19.3 3.3 19.5 3.5C19.7 3.7 19.85 3.93 19.96 4.19C20.07 4.45 20.12 4.72 20.12 5C20.12 5.28 20.07 5.55 19.96 5.81C19.85 6.07 19.7 6.3 19.5 6.5L7 19L3 20L4 16L16.5 3.5Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export default EditIcon
